import Vue from 'vue'


// 引入element-ui
import Element from 'element-ui'
import '@/theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-chalk/display.css'
Vue.use(Element)

// 样式
import 'normalize.css/normalize.css' // 样式重置
import '@/styles/index.scss' // 全局样式


import './perimission'  // 路由权限
import '@/icons'  // svg图标


// 注册全局组件
import Pack from '@cps/Pack'
Vue.component('pack', Pack)

import ZtButton from '@cps/ZtButton'
Vue.component('zt-button', ZtButton)

import AppLink from '@cps/AppLink'
Vue.component('app-link', AppLink)

import ZtTitle from '@cps/ZtTitle'
Vue.component('zt-title', ZtTitle)

import ZtInput from '@cps/ZtInput'
Vue.component('zt-input', ZtInput)

import ZtWrap from '@cps/ZtWrap'
Vue.component(ZtWrap.name, ZtWrap)

import ZtDesc from '@cps/ZtDesc'
Vue.component('zt-desc', ZtDesc)

import ZtDialog from '@cps/ZtDialog'
Vue.component('zt-dialog', ZtDialog)

import { requestResultMessage } from '@/utils'
Vue.prototype.$requestResultMessage = requestResultMessage

Vue.config.productionTip = false

// 添加 <br>和\n互转的格式化方法
import adFormat from '@/utils/adFormat'
Vue.prototype.$adFormat = adFormat

//请求处理
import { requestFormat } from '@/utils/requestFormat'
Vue.prototype.$requestFormat = requestFormat